<template>
  <PageTemplate>
    <TitleWidget>Eventos</TitleWidget>
    <LoadingWidget v-if="loading" />
    <transition name="fade">
      <div v-if="!loading" class="mt-3 mt-sm8 mt-md-10">
        <v-row v-if="items.length">
          <v-col cols="12" md="4" v-for="(item, key) in items" :key="key">
            <GalleriesCard :item="item" />
          </v-col>
          <v-col v-if="pagesLength > 1" class="mt-10" cols="12">
            <v-pagination
              v-model="page"
              :length="pagesLength"
              :total-visible="totalVisibles"
            ></v-pagination>
          </v-col>
        </v-row>
        <v-alert v-else type="warning" class="mt-10">
          Nenhuma galeria adicionada até o momento.
        </v-alert>
      </div>
    </transition>
  </PageTemplate>
</template>

<script>
import GalleriesCard from "../components/cards/GalleriesCard.vue";
import LoadingWidget from "../components/widgets/LoadingWidget.vue";
import PageTemplate from "../components/templates/PageTemplate.vue";
import TitleWidget from "../components/widgets/TitleWidget.vue";
import { formatToURL } from "../utils/formatToURL";
const _config = {
  mod: "galleries",
  path: "/eventos",
  itemsPerPage: 16,
};
export default {
  data: () => ({
    items: [],
    loading: true,
    totalItems: "",
    path: _config.path,
    itemsPerPage: _config.itemsPerPage,
  }),
  computed: {
    page: {
      get() {
        const p = this.$route.query.p;
        return p ? parseInt(p) : 1;
      },
      set(v) {
        const query = { ...this.$route.query };
        query.p = v;
        return this.$router.push({ query });
      },
    },
    totalVisibles() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return 1;
        case "sm":
          return 5;
        default:
          return 9;
      }
    },
    pagesLength() {
      return Math.ceil(this.totalItems / this.itemsPerPage);
    },
  },
  created() {
    this.getItems();
  },
  methods: {
    getItems() {
      this.loading = true;
      const params = {
        returnTotalItems: 1,
        itemsPerPage: this.itemsPerPage,
      };
      if (this.page) params.page = this.page;
      this.$rest(_config.mod)
        .get({
          params,
          keepCache: true,
          save: (state, { totalItems, list }) => {
            this.items = list.map(({ id, title, img, date, address }) => ({
              id,
              title,
              date,
              address,
              to: `${_config.path}/${formatToURL(title)}-${id}`,
              img: img ? this.files + img : undefined,
            }));
            this.totalItems = totalItems;
            if (!list.length && this.page > 1) this.page = 1;
          },
        })
        .then(() => (this.loading = false));
    },
  },
  watch: {
    $route() {
      this.getItems();
    },
    page() {
      this.getItems();
    },
  },
  components: {
    TitleWidget,
    LoadingWidget,
    PageTemplate,
    GalleriesCard,
  },
};
</script>

<style lang="scss">
@media (max-width: 600px) {
  .v-pagination__item,
  .v-pagination__navigation {
    font-size: 16px;
    height: 40px !important;
    margin: 0.3rem;
    min-width: 40px;
    padding: 0 5px;
    text-decoration: none;
    transition: 0.3s cubic-bezier(0, 0, 0.2, 1);
    width: auto !important;
  }
}
</style>
